import HomeActionType from '../../common/HomeActionType';
import FetchAddressService from '../../services/FetchAddressService';
import PlansAction from '../../redux/actions/PlansAction';
import CheckoutActionType from '../../common/CheckoutActionType';
import OrderInfoUtilities from '../../services/FetchOrderInfoService';

const storeSelectedAddressParts = selectedAddressParts =>
  ({ type: HomeActionType.STORE_SELECTED_ADDRESS_PARTS, selectedAddressParts });

const setLoadingVisibility = showLoading =>
  ({ type: HomeActionType.SET_LOADING_VISIBILITY, showLoading });

const storeError = response => ({
  type: HomeActionType.STORE_ERROR,
  status: response.status,
  message: response.message,
  entity: response.entity
});

const fetchPlansAndStoreAddress = async (dispatch, address, isChange, planId) => {
  const { samIds, ...rest } = address || {};
  const selectedAddressParts = {
    samIds: samIds || [],
    ...rest
  };
  await dispatch(PlansAction.storePlanData(planId || selectedAddressParts.tui,
    isChange,
    planId ? selectedAddressParts.tui : null));
  dispatch(storeSelectedAddressParts(selectedAddressParts));
};

const fetchAddressAutoComplete = term => dispatch =>
  FetchAddressService.fetchAddressAutoCompleteWithHandler(
    term,
    response => dispatch({ type: HomeActionType.STORE_ADDRESS_AUTO_COMPLETE, addressAutoComplete: response.entity }),
    // eslint-disable-next-line no-console
    response => console.error(response)  // dispatch(storeError(response));
  );

const fetchAddress = (selectedAddress, isChange, planId) => async (dispatch) => {
  if (!selectedAddress) {
    return;
  }
  dispatch(setLoadingVisibility(true));

  const response = await FetchAddressService.fetchAddress(selectedAddress.id);
  if (response.status === 200 && response.result) {
    await fetchPlansAndStoreAddress(dispatch, response.result, isChange, planId);
  } else {
    dispatch(storeError(response));
  }

  dispatch(setLoadingVisibility(false));
};

const fetchOrderInfo = uuid => async (dispatch) => {
  if (!uuid) {
    return;
  }
  dispatch(setLoadingVisibility(true));

  const response = await OrderInfoUtilities.fetchOrderInfoService(uuid);
  if (response.status === 200 && response.result) {
    const { result: { result: { PlanID, EligibilityStatus, MobileNumber }, address } } = response;
    dispatch(PlansAction.setSelectedPlan(PlanID));
    dispatch(PlansAction.setMobileDiscount({ withMobileDiscount: EligibilityStatus === 'Eligible', linkedMobile: MobileNumber }));
    await fetchPlansAndStoreAddress(dispatch, address, false, PlanID);
    dispatch(setLoadingVisibility(false));
  } else {
    dispatch(storeError(response));
    dispatch(setLoadingVisibility(false));
  }
};

const resetAddressSearch = () => (dispatch) => {
  dispatch({ type: HomeActionType.RESET_ADDRESS_SEARCH });
  dispatch({ type: CheckoutActionType.RESET_ALL });
};

const storePartner = partner => ({ type: HomeActionType.STORE_PARTNER, partner });

const resetAddressSearchAll = () => (dispatch) => {
  dispatch({ type: HomeActionType.RESET_ALL });
};

const HomeAction = {
  fetchAddressAutoComplete,
  fetchAddress,
  resetAddressSearch,
  resetAddressSearchAll,
  storePartner,
  storeError,
  fetchOrderInfo
};

export default HomeAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/HomeAction.js
 **/